import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { Dropdown } from 'semantic-ui-react';
import { patchMenuLink } from 'redux/menu-links/actions';
import { setLastPatchedId } from 'redux/common/actions';

function MenuCurrencyDropdown(props) {
  const { menuItem, currencies, patchMenuLink, setLastPatchedId } = props;
  
  const currencyOptions = currencies ? currencies.map(
    currency => (
      {
        key: currency.currency_code,
        text: currency.currency_code,
        value: currency.id,
        symbol: currency.currency_symbol,
      }
    )
  ) : [];

  return (
    <div className="menu-currency-dropdown__component">
      <Dropdown
        fluid
        selection
        value={menuItem.currency}
        options={currencyOptions}
        onChange={(_e, data) => {
          const form = new FormData();
          form.append('currency', data.value);
          patchMenuLink(menuItem.id, form);
          setLastPatchedId(menuItem.id);
        }}
      />
    </div>
  );
}

MenuCurrencyDropdown.propTypes = {
  menuItem: PropTypes.object.isRequired, 
  currencies: PropTypes.arrayOf(PropTypes.object).isRequired, 
  patchMenuLink: PropTypes.func.isRequired,
  setLastPatchedId: PropTypes.func.isRequired,
}

const mapStateToProps = state => (
  {
    currencies: state.commonReducer.currencies,
  }
)

export default connect(
  mapStateToProps, 
  {
    patchMenuLink,
    setLastPatchedId,
  }
) (MenuCurrencyDropdown);